import React, { memo } from 'react';

import { Icon, Tag } from '~/components';
import type { ArtistDetails } from '~/modules/artist-roster/types';
import { useAnalytics } from '~/modules/monitoring/analytics/useAnalytics';

interface DataToolLinksProps {
  artistData?: ArtistDetails;
}

/**
 * This component is wrapped in React.memo() to prevent unnecessary re-renders with
 * the ScrollCollapse logic. See https://github.com/wmgtech/wmg2-one-app/pull/1747
 */
export const DataToolLinks: React.FC<DataToolLinksProps> = memo(
  ({ artistData }) => {
    const { trackEvent } = useAnalytics('Artist Roster');

    if (!artistData) {
      return null;
    }

    const handleDataToolsLinkClick = () => {
      trackEvent('artistHeroInteraction', {
        artist_id: artistData.partyId,
        artist_name: artistData.name,
      });
    };

    return (
      <div className="flex items-center justify-center gap-sm">
        {artistData.reports.map((report) => (
          <a
            key={report.name}
            href={report.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleDataToolsLinkClick}
          >
            <Tag variant="secondary">
              {report.displayName ?? report.name}
              <Icon
                type="external-link"
                size="sm"
                variant="light"
                role="presentation"
                aria-hidden
                aria-label="external-url-icon"
                className="-mr-px text-white"
              />
            </Tag>
          </a>
        ))}
      </div>
    );
  },
);

DataToolLinks.displayName = 'DataToolLinks';
